export const selectSignConnectionPlaceholder = `We have noticed that you have not yet selected an E-Sign Method for signing your documents. Please choose one of the available options below to successfully submit your documents.`;
